import {useLazyQuery, useMutation} from "@apollo/client";
import {IonRouterLink} from "@ionic/react";
import dayjs from "dayjs";
import React, {useEffect} from "react";
import toast from "react-hot-toast";

import {Breadcrumbs} from "../../../components";
import {UPDATE_ESTIMATE_STATUS} from "../../../graphql/mutations/quote.mutation";
import {GET_ALL_MY_QUOTES} from "../../../graphql/queries/quote.query";
import PrivacyPolicy from "../Carrello/PrivacyPolicy";

import "./preventivi.style.css";
import ChatIcon from "../../../components/ChatIcon";
import CompleteProfileModal from "../Carrello/CompleteProfileModal";
import Loading from "../../../components/Loading";
import Pagination from "../../../components/pagination/pagination";

export default function Preventivi() {
  const [offset, setOffset] = React.useState(0);
  const limit = 10;

  const [privacyView, setPrivacyView] = React.useState(false);
  const [quoteList, setOrderList] = React.useState<any[]>([]);
  const [selectedQuote, setSelectedQuote] = React.useState<number>();
  const [completeProfileModal, setCompleteProfileModal] = React.useState<boolean>(false);

  const [fetchQuotes, {data, loading}] = useLazyQuery(GET_ALL_MY_QUOTES, {
    variables: {
      limit,
      offset,
    },
    fetchPolicy: 'network-only',
    onCompleted(data) {
      setOrderList(data.getMyPaginatedEstimates.data);
    },
  });

  const [updateEstimateStatus] = useMutation(UPDATE_ESTIMATE_STATUS, {
    onCompleted(data) {
      if (data?.updateEstimateStatus?.errors) {
        const errorMessage = data.updateEstimateStatus.errors[0].message ?? "";
        if (errorMessage === "COMPLETE_YOUR_PROFILE") {
          setCompleteProfileModal(true);
        }
      } else {
        toast.success("Status aggiornato correttamente!");
        fetchQuotes();
      }
    },
  });

  useEffect(() => {
    fetchQuotes();
  }, []);

  const getStatusText = (status: string) => {
    switch (status) {
      case "notVerified":
        return "Da verificare";
      case "unread":
        return "Non letto";
      case "pending":
        return "In attesa di approvazione";
      case "accepted":
      case "transformedToOrder":
        return "Accettato";
      case "rejected":
        return "Rifiutata";
      default:
        return "";
    }
  };

  const breadcrumbEntries = [
    {title: "Area personale", link: "/personale"},
    {title: "Preventivi"},
  ];

  const updateStatus = () => {
    updateEstimateStatus({
      variables: {
        id: selectedQuote,
        status: "accepted",
      },
    });
  };

  if (loading) return <Loading />;

  return (
    <div className="app-container">
      <Breadcrumbs items={breadcrumbEntries} />

      <div className="servizi-container">
        <table className="responsive-table">
          <thead>
            <tr>
              <th>Numero preventivo</th>
              <th>Data</th>
              <th>Orario</th>
              <th>Stato completamento</th>
              <th>Telefono</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {quoteList.map((quote, index) => (
              <tr key={index}>
                <td data-label="Numero preventivo">{quote.id}</td>
                <td data-label="Data">
                  {dayjs(quote.createdAt).format("DD/MM/YYYY")}
                </td>
                <td data-label="Orario">
                  {dayjs(quote.createdAt).format("HH:mm")}
                </td>
                <td data-label="Stato completamento">
                  {getStatusText(quote.status)}
                </td>
                <td data-label="Telefono">{quote.telephone ?? "-"}</td>
                <td>
                  <div className="flex-buttons">
                    <div style={{marginTop: 1, marginBottom: 1}}>
                      <ChatIcon
                        roomId={quote.roomId}
                        id={quote.id}
                        category="estimate"
                        orderNumber={""}
                      />
                    </div>
                    <IonRouterLink
                      href={`/personale/preventivi/${quote.id}`}
                      className="gap-around"
                      style={{marginTop: 1, marginBottom: 1}}
                    >
                      <div className="servizi-button">Vedi dettagli</div>
                    </IonRouterLink>
                    <div style={{marginTop: 1, marginBottom: 1}}>
                      <button
                        className="confirm-button"
                        disabled={quote.status !== "pending"}
                        onClick={() => {
                          setSelectedQuote(quote.id);
                          setPrivacyView(true);
                        }}
                      >
                        Conferma preventivo
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {quoteList.length < 1 && <div className='no-items'>Nessuna Preventivi!</div>}
        <div
          style={{
            display: 'flex',
            justifyContent: 'end',
            alignItems: 'center',
            marginTop: '40px',
          }}
        >
          <Pagination
            total={data?.getMyPaginatedEstimates?.count ?? 0}
            limit={limit}
            offset={offset}
            onChange={setOffset}
          />
        </div>
      </div>
      <PrivacyPolicy
        visible={privacyView}
        dismiss={() => setPrivacyView(false)}
        submitForm={updateStatus}
        type="order"
      />
      <CompleteProfileModal
        onClose={() => setCompleteProfileModal(false)}
        visible={completeProfileModal}
      />
    </div>
  );
}
